export type ParsedUrlQuery = Record<string, string | string[] | undefined>;
export type QueryParamValue = string | number | boolean | readonly string[] | readonly number[] | readonly boolean[] | null | undefined;
export type QueryParams = Record<string, QueryParamValue>;

/**
 * Stringifies query parameters to a URL query string.
 * Handles arrays by appending multiple entries with the same key (e.g., key=1&key=2).
 * This matches the behavior of the deprecated `querystring.stringify()`.
 */
export const stringifyParams = (params: QueryParams): string => {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;
        if (Array.isArray(value)) {
            for (const item of value) {
                searchParams.append(key, String(item));
            }
        } else {
            searchParams.append(key, String(value));
        }
    }
    return searchParams.toString();
};
